import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex justify-between items-center text-xs gap-4 items-center" }
const _hoisted_2 = { class: "flex flex-col gap-2 flex-shrink-0 items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Verify Email", -1)
const _hoisted_4 = { class: "flex flex-col gap-2 flex-shrink-0 items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Verify Phone Number", -1)
const _hoisted_6 = { class: "flex flex-col gap-2 flex-shrink-0 items-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Create account", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "w-1/2 mx-auto text-center opacity-60 my-4" }, " We just sent you a temporary verification code. Please check your inbox and paste the verificaiton code below. ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "w-1/2 mx-auto text-center opacity-60 my-4" }, " We just sent you a temporary verification sms code. Please check your phone and paste the verificaiton ms code below. ", -1)
const _hoisted_10 = { class: "text-center mt-4" }

import {
	useCompanyProfile,
	useRegister
} from '@/account/composition';
import {
	UiButton,
	UiForm,
	UiInput,
	UiLink,
	useForm,
	usePasswordToggling
} from '@/ui-kit';
import {
	email,
	required,
	requiredIf
} from '@vuelidate/validators';
import { ref } from 'vue';
import AuthContainer from '../../components/AuthContainer.vue';
import { phoneNumber } from '@/utils/validations';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'Register',
  setup(__props) {

const router = useRouter();

const registrationStep = ref<
	| 'email'
	| 'emailVerification'
	| 'phoneNumber'
	| 'phoneNumberVerification'
	| 'createAccount'
>('email');

const {
	sendVerificationEmail,
	validateEmail,
	sendVerificationSms,
	verifyPhoneNumber,
	register
} = useRegister();
const { loadProfile } = useCompanyProfile();

const { onSubmit, loading, formData, resetForm } = useForm(
	{
		email: '',
		phone_number: '',
		password: '',
		code: '',
		phone_number_country: 'US'
	},
	{
		email: {
			required,
			email
		},
		phone_number: {
			phoneNumber,
			required: requiredIf(
				(): boolean =>
					registrationStep.value === 'phoneNumber'
			)
		},
		password: {
			required: requiredIf(
				(): boolean =>
					registrationStep.value ===
					'createAccount'
			)
		},
		code: {
			required: requiredIf(
				(): boolean =>
					registrationStep.value ===
						'emailVerification' ||
					registrationStep.value ===
						'phoneNumberVerification'
			)
		}
	}
);

const submit = onSubmit(async (data) => {
	switch (registrationStep.value) {
		case 'email': {
			const { status } = await sendVerificationEmail(
				data.email
			);

			if (status === 'approved') {
				registrationStep.value = 'phoneNumber';
			} else {
				registrationStep.value =
					'emailVerification';
			}
			return resetForm(data);
		}
		case 'emailVerification': {
			await validateEmail(data.email, data.code);
			registrationStep.value = 'phoneNumber';
			return resetForm(data);
		}
		case 'phoneNumber': {
			const { status } = await sendVerificationSms(
				data.phone_number,
				data.phone_number_country
			);

			if (status === 'approved') {
				registrationStep.value = 'createAccount';
			} else {
				registrationStep.value =
					'phoneNumberVerification';
			}
			return resetForm({ data, code: '' });
		}
		case 'phoneNumberVerification': {
			await verifyPhoneNumber(
				data.phone_number,
				data.phone_number_country,
				data.code
			);
			registrationStep.value = 'createAccount';
			return resetForm(data);
		}
		case 'createAccount': {
			await register(data);
			await loadProfile();
			await router.replace({
				name: 'OnboardingStep1'
			});
		}
	}
});

const { passwordIcon, togglePasswordType, passwordType } =
	usePasswordToggling();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AuthContainer, {
    title: "Steps Away from a Unified Business.",
    cardTitle: "Create your account"
  }, {
    outerBlock: _withCtx(() => [
      _createElementVNode("div", _hoisted_10, [
        _createTextVNode(" Have an account? "),
        _createVNode(_unref(UiLink), {
          size: "lg",
          to: { name: 'Login' }
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Sign in")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(["h-8 w-8 transition rounded-full flex items-center justify-center text-sm border border-solid font-medium shadow-md", 
						registrationStep.value !== 'email' &&
						registrationStep.value !==
							'emailVerification'
							? 'bg-green-400 text-white'
							: 'bg-gray-blue'
					])
          }, " 1 ", 2),
          _hoisted_3
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["w-full h-0.5 transition", 
					registrationStep.value !== 'email' &&
					registrationStep.value !== 'emailVerification'
						? 'bg-green-400 text-white'
						: 'bg-gray-blue'
				])
        }, null, 2),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass(["h-8 w-8 rounded-full transition flex items-center justify-center text-sm border border-solid font-medium shadow-md", {
						'bg-white':
							registrationStep.value === 'email' ||
							registrationStep.value ===
								'emailVerification',
						'bg-gray-blue':
							registrationStep.value ===
								'phoneNumber' ||
							registrationStep.value ===
								'phoneNumberVerification',
						'bg-green-400 text-white':
							registrationStep.value ===
							'createAccount'
					}])
          }, " 2 ", 2),
          _hoisted_5
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["w-full h-0.5 transition", 
					registrationStep.value === 'createAccount'
						? 'bg-green-400'
						: 'bg-gray-blue'
				])
        }, null, 2),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: _normalizeClass(["h-8 w-8 rounded-full transition flex items-center justify-center text-sm border border-solid font-medium shadow-md", {
						'bg-gray-blue':
							registrationStep.value ===
							'createAccount'
					}])
          }, " 3 ", 2),
          _hoisted_7
        ])
      ]),
      _createVNode(_unref(UiForm), {
        class: "mt-8",
        onSubmit: _unref(submit)
      }, {
        default: _withCtx(() => [
          (registrationStep.value === 'email')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_unref(UiInput), {
                  disabled: _unref(loading),
                  label: "Email",
                  name: "email",
                  type: "email",
                  modelValue: _unref(formData).email,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formData).email) = $event))
                }, null, 8, ["disabled", "modelValue"]),
                _createVNode(_unref(UiButton), { loading: _unref(loading) }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Verify Email ")
                  ]),
                  _: 1
                }, 8, ["loading"])
              ], 64))
            : (
					registrationStep.value === 'emailVerification'
				)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_8,
                  _createVNode(_unref(UiInput), {
                    disabled: _unref(loading),
                    label: "Email Verification Code",
                    name: "code",
                    placeholder: "Paste verification code here",
                    modelValue: _unref(formData).code,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formData).code) = $event))
                  }, null, 8, ["disabled", "modelValue"]),
                  _createVNode(_unref(UiButton), { loading: _unref(loading) }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Verify email ")
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ], 64))
              : _createCommentVNode("", true),
          (registrationStep.value === 'phoneNumber')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createVNode(_unref(UiInput), {
                  disabled: _unref(loading),
                  label: "Phone number",
                  name: "phone_number",
                  type: "phone",
                  onCountryChanged: _cache[2] || (_cache[2] = ($event: any) => (
						_unref(formData).phone_number_country =
							$event
					)),
                  modelValue: _unref(formData).phone_number,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(formData).phone_number) = $event))
                }, null, 8, ["disabled", "modelValue"]),
                _createVNode(_unref(UiButton), { loading: _unref(loading) }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Verify phone number ")
                  ]),
                  _: 1
                }, 8, ["loading"])
              ], 64))
            : (
					registrationStep.value ===
					'phoneNumberVerification'
				)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _hoisted_9,
                  _createVNode(_unref(UiInput), {
                    disabled: _unref(loading),
                    label: "SMS Verification Code",
                    name: "code",
                    placeholder: "Paste verification code here",
                    modelValue: _unref(formData).code,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(formData).code) = $event))
                  }, null, 8, ["disabled", "modelValue"]),
                  _createVNode(_unref(UiButton), { loading: _unref(loading) }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Verify phone number ")
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ], 64))
              : _createCommentVNode("", true),
          (registrationStep.value === 'createAccount')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                _createVNode(_unref(UiInput), {
                  disabled: "",
                  label: "Email",
                  name: "email",
                  type: "email",
                  modelValue: _unref(formData).email,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(formData).email) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_unref(UiInput), {
                  disabled: "",
                  label: "Phone number",
                  name: "phone_number",
                  type: "phone",
                  modelValue: _unref(formData).phone_number,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(formData).phone_number) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_unref(UiInput), {
                  label: "Password",
                  name: "password",
                  type: _unref(passwordType),
                  disabled: _unref(loading),
                  icon: _unref(passwordIcon),
                  onIconClicked: _unref(togglePasswordType),
                  modelValue: _unref(formData).password,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(formData).password) = $event))
                }, null, 8, ["type", "disabled", "icon", "onIconClicked", "modelValue"]),
                _createVNode(_unref(UiButton), { loading: _unref(loading) }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Create account ")
                  ]),
                  _: 1
                }, 8, ["loading"])
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ]),
    _: 1
  }))
}
}

})